// Field-value JSON API instance.
// Kept as a separate file so callers don't need to change their imports,
// but the implementation is shared via createApiInstance.
import { createApiInstance } from './Createapiinstance';

export default createApiInstance('application/json');